import { Injectable } from '@angular/core';
import { delay, Observable } from 'rxjs';
import { userMeMockData } from '@mock/data/user-me-mock.data';
import { IApiResponse } from '@app/api/interfaces/common/api-response.interface';
import { IUserMe } from '@app/api/interfaces/user-me.interface';
import { MockService } from '@mock/mock.service';

@Injectable({
  providedIn: 'root',
})
export class UserMeMockService extends MockService {
  public get(): Observable<IApiResponse<IUserMe, object>> {
    return this.mockResponse('USER:get', {
      data: { ...userMeMockData, type: this.getUserType() },
      meta: {},
    }).pipe(delay(this.requestDelay));
  }
}
